"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as h } from "react";
import r from "../components/Icon/SvgIcon.js";
const l = (e) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "M21.416 6.706h-.998l-1.102-2.533a1.54 1.54 0 0 0-1.403-.923H6.096c-.612 0-1.158.358-1.403.923L3.591 6.706H2.584A.587.587 0 0 0 2 7.29v3.766c0 .32.264.584.584.584h.414v8.446c0 .32.264.584.584.584h16.836c.32 0 .584-.264.584-.584V11.64h.414c.32 0 .584-.264.584-.584V7.29a.587.587 0 0 0-.584-.584M3.177 7.883h17.655v2.59H3.177zm5.301 11.629v-5.415h7.044v5.415z"
      }
    )
  }
), i = h(l);
export {
  i as WarehouseFilled,
  i as default
};
